<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { AutoForm } from '@/ui-plus/auto-form'
import { toTypedSchema } from '@vee-validate/zod'
import { useForm } from 'vee-validate'
import { z } from "zod";
import { verifyOTP } from '@auth-frontend-vue/lib/auth.actions';
import { useFormPlus } from '@/ui-plus/form/useFormPlus'
import { Loader2 } from 'lucide-vue-next'
import AutoFormFieldPin from "@/ui-plus/auto-form/AutoFormFieldPin.vue";

const props = defineProps<{
    verifyEmail: string
}>();

const emit = defineEmits<{
    onSuccess: [values: z.infer<typeof schema>],
    onCancel: [],
    onError: [error: any],
}>();

const schema = z.object({
    verifyEmail: z.string().email(),
    code: z.string().length(4, { message: '4 digits required' }),
})

const form = useForm({
    validationSchema: toTypedSchema(schema),
})

const { isLoading, globalError, handleError, withSubmit } = useFormPlus(form);

form.setFieldValue("verifyEmail", props.verifyEmail);
async function onSubmit(values: z.infer<typeof schema>) {
    await withSubmit(async () => {
        const { data, error } = await verifyOTP({
            ...values,
        });
        if (error) {
            // if (error.code === 'TWO_FACTOR_AUTH_REQUIRED') {
            //     emit('onError', error);
            // } else {
            //     handleError(error, form);
            // }
            handleError(error, form);
        } else {
            // Success
            console.log(data);
            // await refreshUserData();
            emit('onSuccess', values);
        }
    })
}
</script>

<template>
    <AutoForm class="space-y-6"
              :schema="schema"
              :form="form"
              @submit="onSubmit"
              :field-config="{
                verifyEmail: {
                    label: 'Email',
                    inputProps: {
                        disabled: true,
                        autocomplete: 'email',
                    },
                },
                code: {
                    component: AutoFormFieldPin,
                    label: 'One-time password',
                    description: 'Enter the code we sent to your email',
                    inputProps: {
                        // @ts-ignore
                        length: 4,
                        autocomplete: 'one-time-code',
                        autofocus: true,
                    },
                },
            }">
        <div class="text-sm font-medium text-destructive"
             v-if="globalError">
            {{ globalError }}
        </div>
        <div>
            <Button type="submit"
                    :disabled="isLoading"
                    class="w-full my-6">
                <Loader2 v-if="isLoading"
                         class="animate-spin" />
                Verify
            </Button>
        </div>
    </AutoForm>
    <Button variant="secondary"
            @click="emit('onCancel')"> Cancel </Button>
</template>
